module.exports = __webpack_public_path__ + "static/toDoList-1e65992c06b08dd9d3d56a026eedb1ec.jpg";